import * as React from "react";
const IconCz = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h513v342H0z" />
    <path  d="M513 171v171H0l215-171z" />
    <path  d="M513 0v171H215.185L0 0z" />
  </svg>
);
export default IconCz;
